document.querySelectorAll('.care-uses').forEach(sectionCareUses => {

    const careUsesNavigationItems = sectionCareUses.querySelectorAll('.navigation .item');
    const careUsesContentsBlocks = sectionCareUses.querySelectorAll('.contents .block');
    const careUsesContentsDotContainer = sectionCareUses.querySelector('.dots');
    const careUsesContentsControlsBtns = sectionCareUses.querySelectorAll('.controls .btn');

    /* TABS */
    careUsesNavigationItems.forEach(item => {
        item.addEventListener('click', () => {
            for(let i=0;i<careUsesNavigationItems.length;i++){
                if(careUsesNavigationItems[i].id == item.id){
                    careUsesNavigationItems[i].classList.add('active');
                    careUsesContentsBlocks[i].classList.add('active');
                }else{
                    careUsesNavigationItems[i].classList.remove('active');
                    careUsesContentsBlocks[i].classList.remove('active');
                }
            }
            updateCareUsesBlockItems();
        })
    })

    /* DOTS */
    function updateCareUsesBlockItems(){
        const careUsesContentsBlockItems = sectionCareUses.querySelectorAll('.contents .block.active .item');
        careUsesContentsDotContainer.innerHTML = '';
        for(let i=0;i<careUsesContentsBlockItems.length;i++){
            const newDot = document.createElement('div');
            newDot.id = i+1;
            newDot.classList.add('dot');
            if(i==0){ newDot.classList.add('active'); }
            newDot.innerHTML = '<div class="round"></div>';
            careUsesContentsDotContainer.appendChild(newDot);
        }
    }
    updateCareUsesBlockItems();

    /* CONTROLS */
    careUsesContentsControlsBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const careUsesContentsDots = sectionCareUses.querySelectorAll('.dots .dot');
            let slideIdSave = 0;
            if(btn.id == 'right'){
                for(let i=0;i<careUsesContentsDots.length;i++){
                    if(careUsesContentsDots[i].classList.contains('active') == true){
                        slideIdSave = (i<careUsesContentsDots.length-1) ? i+2 : 1;
                    }
                    careUsesContentsDots[i].classList.remove('active');
                }
            }else if(btn.id == 'left'){
                for(let i=0;i<careUsesContentsDots.length;i++){
                    if(careUsesContentsDots[i].classList.contains('active') == true){
                        slideIdSave = (i==0) ? careUsesContentsDots.length : i;
                    }
                    careUsesContentsDots[i].classList.remove('active');
                }
            }
            careUsesContentsDots[slideIdSave-1].classList.add('active');
            const activeBlock = sectionCareUses.querySelector('.contents .block.active');
            const blockWidth = sectionCareUses.clientWidth;
            activeBlock.style.transform = `translateX(-${(blockWidth-10)*(slideIdSave-1)}px)`;
        })
    })

})